// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"7dcde19a","340":"d8f9cf23","715":"03557a7f"}[chunkId] + ".css";
};